export function useSingletonComposable<ResultType>(initComposable: () => ResultType): () => ResultType {
    const composable = initComposable();

    return () => composable;
}
